module.exports = __webpack_public_path__ + "assets/img/18_186_big.598f28bd.jpg";